import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState, useEffect } from "react";
import { MyFetch } from "../../App";
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import moment from "moment";

const ClientEdit = (props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const [showDeleteModal, setShowDeleteModal] = useState(false); // For delete confirmation modal
    const [validated, show_Validation] = useState(false);
    const [form_Data, set_Form_Data] = useState({
        name: "",
        mobile: "",
        email: "",
        address: "",
        city: "",
    });

    useEffect(() => {
        MyFetch(`https://easytasks.in/client/list/${location.state.clientid}`, {}, "GET")
            .then((res) => res.json())
            .then((data) => set_Form_Data(data));

    }, [])

    const deleteFn = () => {
        MyFetch(`https://easytasks.in/client/delete`, form_Data, "DELETE")
            .then((res) => {
                if (res.status === 200) {
                    alert("client deleted successfully!")
                    navigate('/client/list');
                } else {
                    alert("Failed to delete client.");
                }
            })
            .catch((error) => {
                console.error("Error deleting client:", error);
                alert("Error deleting client.");
            });
    };

    const submitFn = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        show_Validation(true); //to display whether valid or invalid 

        if (form.checkValidity() === true) {
            MyFetch("https://easytasks.in/client/update", form_Data, "PUT")
                .then((res) => res.json())
                .then((data) => {
                    alert("Client created successfully!"); // Notify the user
                    navigate('/client/list')
                }).catch((error) => {
                    console.error("Error creating client:", error);
                    alert("Failed to create client."); // Notify the user of any errors
                });
        } else {
            event.stopPropagation(); // Prevent the form from submitting if validation fails
        }
    };


    const chngFn = (event) => {
        const { name, value } = event.target;
        set_Form_Data({
            ...form_Data,
            [name]: value,
        });
    };

    return (

        <Container className='mt-5'>
            <Row className="justify-content-md-center">
                <Col xs lg="5" >
                    <h2 className='my-5'><b>EDIT CLIENT DETAILS</b></h2>
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs lg="5">
                    <Form noValidate validated={validated} onSubmit={submitFn}>
                        {console.log(validated)}
                        <Form.Group className="mb-3" controlId="clientName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={form_Data.name}
                                onChange={chngFn}
                                pattern="^[a-zA-Z0-9 ]+$"
                                required
                                isInvalid={
                                    validated &&
                                    !/^[a-zA-Z0-9 ]+$/.test(form_Data.name)
                                }
                            />
                            <Form.Control.Feedback type="invalid">
                                Please enter a valid username (alphanumeric
                                characters only).
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="clientMobile">
                            <Form.Label>Mobile</Form.Label>
                            {/* check validation - it is showing tick even though it is invalid */}
                            <Form.Control
                                type="number"
                                name="mobile"
                                value={form_Data.mobile}
                                onChange={chngFn}
                                pattern="^\d{10}$"
                                required
                                isInvalid={
                                    validated &&
                                    !/^\d{10}$/.test(form_Data.mobile)
                                }
                            />
                            <Form.Control.Feedback type="invalid">
                                Please enter a valid 10-digit phone number.
                            </Form.Control.Feedback>
                        </Form.Group>


                        <Form.Group className="mb-3" controlId="clientEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                placeholder="name@example.com"
                                type="email"
                                name="email"
                                value={form_Data.email}
                                onChange={chngFn}
                                required
                                isInvalid={
                                    validated &&
                                    !/^\S+@\S+\.\S+$/.test(form_Data.email)
                                }
                            />
                            <Form.Control.Feedback type="invalid">
                                Please enter a valid email address.
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="clientAddress">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="address"
                                value={form_Data.address}
                                onChange={chngFn}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="clientCity">
                            <Form.Label>City</Form.Label>
                            <Form.Control
                                type="text"
                                name="city"
                                value={form_Data.city}
                                onChange={chngFn}
                                pattern="^[a-zA-Z ]+$"
                                required
                                isInvalid={
                                    validated &&
                                    !/^[a-zA-Z ]+$/.test(form_Data.city)
                                }
                            />
                            <Form.Control.Feedback type="invalid">
                                Please enter a valid city (alphabets only).
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Button variant="primary" type="submit"> Update</Button>{' '}
                        <Button variant="danger" onClick={() => setShowDeleteModal(true)}>Delete</Button>

                    </Form>
                </Col>
            </Row>
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this task?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        No
                    </Button>
                    <Button variant="danger" onClick={() => {
                        deleteFn();
                        setShowDeleteModal(false);
                    }}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export default ClientEdit;

